import { useEffect, useState } from "react"
import { FaBirthdayCake, FaBox, FaCalendar, FaCheck, FaDollarSign, FaEdit, FaFolder, FaGlobe, FaIdCardAlt, FaInfo, FaMapMarkerAlt, FaMoneyBill, FaPhone, FaPlus, FaRegCalendarAlt, FaSave, FaSuitcase, FaSync, FaTimes, FaTrash, FaUser, FaUserCog, FaUsers, FaUsersCog } from "react-icons/fa";
import { MdEmail, MdPerson, MdWorkspaces } from "react-icons/md";
import { BACKEND } from "../config/configEnvs"
import { toast } from "react-toastify"
import axios from "axios"
import { useSelector } from "react-redux"
import PaginationItem from "../components/ui/components/Pagination"
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import Selector from "../components/ui/components/Selector"
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import { FormatDateString  } from "../utils/FormatDate"
import { RucVerifier } from "../utils/verifyData/RucVerifier"
import Modal from "../components/ui/Modal"
import FormLoader from "../components/ui/FormLoader";
import InputFormValue from "../components/ui/components/InputFormValue";
import AddIcon from "@mui/icons-material/Add";
import FilterHeadersDialog from "../components/dialogs/FilterHeadersDialog";
import FilterButton from "../components/ui/components/FilterButton";
import GetCountries from "../utils/getData/GetCountries";
import EditButton from "../components/ui/components/EditButton";
import DeleteButton from "../components/ui/components/DeleteButton";
import DinamicBoxButton from "../components/ui/components/DinamicBoxButton";
import DinamicButton from "../components/ui/components/DinamicButton";
import ItemRowProductStakeholder from "../components/stakeholders/ItemRowProductStakeholder";
import InputRowValue from "../components/ui/components/InputRowValue";
import TiposProducto from "../utils/plainValues/TiposProducto";
import TiposCosto from "../utils/plainValues/TiposCosto";

const Stakeholders = () => {

  const user = useSelector((state) => state.auth.user)
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION"

  const [loadingStatus, setLoadingStatus] = useState(false)
  const [limit, setLimit] = useState(50)
  const [page, setPage] = useState(1)

  const [name, setName] = useState("")

  const [countries, setCountries] = useState([])
  const [headersTableActive, setHeadersTableActive] = useState([])

  const [record, setRecord] = useState([])
  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const [rucVerify, setRucVerify] = useState(false)
  const [isRucLoading, setIsRucLoading] = useState(false)

  const [newStakeholderModal, setNewStakeholderModal] = useState(false)
  const [editStakeholderModal, setEditStakeholderModal] = useState(false)

  const [openFilter, setOpenFilter] = useState(false)

  const [editStakeholder, setEditStakeholder] = useState({
    country: "Perú",
    ruc: "",
    socialReason: "",
    rubro: "",
    nicho: "",
    commercialName: "",
    address: "",
    foundationDate: "",
    numberOfEmployees: "",
    description: "",
    businessSector: "",
    managerName: "",
    managerBirthday: "",
    managerPhone: "",
    salesEmail: "",
    salesPhone: "",
    email: "",
    phone: "",
    linkFacebook: "",
    linkInstagram: "",
    linkLinkedin: "",
    linkYoutube: "",
    linkTiktok: "",
  })

  const [newStakeholder, setNewStakeholder] = useState({
    country: "Perú",
    ruc: "",
    socialReason: "",
    rubro: "",
    nicho: "",
    commercialName: "",
    address: "",
    foundationDate: "",
    numberOfEmployees: "",
    description: "",
    businessSector: "",
    managerName: "",
    managerBirthday: "",
    managerPhone: "",
    salesEmail: "",
    salesPhone: "",
    email: "",
    phone: "",
    linkFacebook: "",
    linkInstagram: "",
    linkLinkedin: "",
    linkYoutube: "",
    linkTiktok: "",
  })

  const resetNewStakeholderForm = () => {
    setNewStakeholder({
      country: "Perú",
      ruc: "",
      socialReason: "",
      commercialName: "",
      address: "",
      foundationDate: "",
      numberOfEmployees: "",
      description: "",
      businessSector: "",
      managerName: "",
      managerBirthday: "",
      managerPhone: "",
      salesEmail: "",
      salesPhone: "",
      email: "",
      phone: "",
      linkFacebook: "",
      linkInstagram: "",
      linkLinkedin: "",
      linkYoutube: "",
      linkTiktok: "",
    })
  }

  const getRecord = async () => {
    try {
      setLoadingStatus(true)
      let url = `${BACKEND}/api/stakeholders?limit=${limit}&page=${page}`
      
      if (name) {
        url += `&where[commercialName][like]=${name}`
      }

      const response = await axios.get(url)
      setRecord(response.data.docs)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)
    } catch (e) {
      return false
    } finally {
      setLoadingStatus(false)
    }
  }

  const SubmitStakeholder = async (e) => {
    e.preventDefault()
    try {
      console.log(newStakeholder)
      await axios.post(`${BACKEND}/api/stakeholders`, {
        ...newStakeholder,
        foundationDate: newStakeholder.foundationDate ? new Date(newStakeholder.foundationDate).toISOString() : null,
        managerBirthday: newStakeholder.managerBirthday ? new Date(newStakeholder.managerBirthday).toISOString() : null,
        numberOfEmployees: newStakeholder.numberOfEmployees ? Number(newStakeholder.numberOfEmployees) : null,
      })
      toast.success("Stakeholder creado correctamente")
      setNewStakeholderModal(false)
      resetNewStakeholderForm()
      getRecord()
    } catch (e) {
      console.log(e)
      toast.error("Error al crear el stakeholder")
    }
  }

  const DeleteStakeholder = async (id) => {
    try {
      const confirm = window.confirm("¿Estás seguro de querer eliminar este stakeholder?")
      if (!confirm) return
      await axios.delete(`${BACKEND}/api/stakeholders/${id}`)
      toast.success("Stakeholder eliminado correctamente")
      getRecord()
      setRucVerify(false)
    } catch (e) {
      console.log(e)
      toast.error("Error al eliminar el stakeholder")
    }
  }

  const UpdateStakeholder = async () => {
    try {
      const rubroName = rubros.find((r) => r.id === editStakeholder.rubro)?.name ?? null
      const nichoName = nichos.find((n) => n.id === editStakeholder.nicho)?.name ?? null

      await axios.put(`${BACKEND}/api/stakeholders/${editStakeholder.id}`, {
        ...editStakeholder,
        foundationDate: editStakeholder.foundationDate ? new Date(editStakeholder.foundationDate).toISOString() : null,
        managerBirthday: editStakeholder.managerBirthday ? new Date(editStakeholder.managerBirthday).toISOString() : null,
        numberOfEmployees: editStakeholder.numberOfEmployees || null,
        rubro: rubroName,
        nicho: nichoName,
      })
      toast.success("Stakeholder actualizado correctamente")
      setEditStakeholderModal(false)
      setRucVerify(false)
      getRecord()
    } catch (e) {
      console.log(e)
      toast.error("Error al actualizar el stakeholder")
    }
  }

  const formatStakeholderForEdit = (stakeholder) => {
    const rubroId = (() => {
      if (!stakeholder.rubro) return ""
      const byId = rubros.find((r) => r.id === stakeholder.rubro)
      if (byId) return byId.id
      const byName = rubros.find((r) => r.name === stakeholder.rubro)
      return byName ? byName.id : ""
    })()

    const nichoId = (() => {
      if (!stakeholder.nicho) return ""
      const byId = nichos.find((n) => n.id === stakeholder.nicho)
      if (byId) return byId.id
      const byName = nichos.find((n) => n.name === stakeholder.nicho)
      return byName ? byName.id : ""
    })()

    return {
      ...stakeholder,
      foundationDate: stakeholder.foundationDate ? new Date(stakeholder.foundationDate).toISOString().split('T')[0] : "",
      managerBirthday: stakeholder.managerBirthday ? new Date(stakeholder.managerBirthday).toISOString().split('T')[0] : "",
      rubro: rubroId,
      nicho: nichoId,
    }
  }

  const handleSearchRecord = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getRecord()
  }

  useEffect(() => {
    getRecord()
  }, [])

  useEffect(() => {
    getRecord()
  }, [limit, page])

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }
  
  const handleResetSearch = () => { // Resetea la búsqueda
    setName(""); // Cambiar el estado
  };

  useEffect(() => { 
    if (name === "") {
      setPage(1); 
      getRecord()
    }
  }, [name]);

  useEffect(() => {
    const localActiveHeaders = JSON.parse(localStorage.getItem("activeTableColsStakeholders")) || [];
    if (localActiveHeaders.length > 0) {
      const sanitized = localActiveHeaders
        .filter((stored) => headers.some((h) => h.id === stored.id))
        .map((stored) => {
          const current = headers.find((h) => h.id === stored.id)
          return { ...current, show: stored.show ?? current.show }
        })
      const missing = headers.filter((h) => !sanitized.some((s) => s.id === h.id))
      const merged = [...sanitized, ...missing]
      setHeadersTableActive(merged)
      localStorage.setItem("activeTableColsStakeholders", JSON.stringify(merged))
    } else {
      setHeadersTableActive(headers)
    }

    GetCountries({setter: setCountries})
  }, []);

  useEffect(() => {
    if (headersTableActive.length > 0) {
      localStorage.setItem("activeTableColsStakeholders", JSON.stringify(headersTableActive));
    }
  }, [headersTableActive]);

  const headers = [
    { id: 1, name: "Acciones", value: "actions", show: true },
    { id: 2, name: "País", value: "country", show: true },
    { id: 3, name: "RUC", value: "ruc", show: true },
    { id: 4, name: "Razón Social", value: "socialReason", show: true },
    { id: 5, name: "Nombre Comercial", value: "commercialName", show: true },
    { id: 6, name: "Rubro", value: "rubro", show: true, formatter: (v) => {
      if (!v) return "-"
      const found = rubros.find((r) => r.id === v || r.name === v)
      return found?.name || v
    } },
    { id: 7, name: "Nicho", value: "nicho", show: true, formatter: (v) => {
      if (!v) return "-"
      const found = nichos.find((n) => n.id === v || n.name === v)
      return found?.name || v
    } },
    { id: 8, name: "Dirección", value: "address", show: true },
    { id: 9, name: "Fecha de fundación", value: "foundationDate", show: true, formatter: FormatDateString },
    { id: 10, name: "Número de empleados", value: "numberOfEmployees", show: true },
    { id: 11, name: "Descripción", value: "description", show: true },
    { id: 12, name: "Sector empresarial", value: "businessSector", show: true },
    { id: 13, name: "Nombre del gerente", value: "managerName", show: true },
    { id: 14, name: "Email del gerente", value: "managerEmail", show: true },
    { id: 15, name: "Fecha de nacimiento del gerente", value: "managerBirthday", show: true, formatter: FormatDateString },
    { id: 16, name: "Teléfono del gerente", value: "managerPhone", show: true },
    { id: 17, name: "Email de ventas", value: "salesEmail", show: true },
    { id: 18, name: "Teléfono de ventas", value: "salesPhone", show: true },
    { id: 19, name: "Email", value: "email", show: true },
    { id: 20, name: "Teléfono", value: "phone", show: true },

    { id: 21, name: "Link Facebook", value: "linkFacebook", show: true },
    { id: 22, name: "Link Instagram", value: "linkInstagram", show: true },
    { id: 23, name: "Link Linkedin", value: "linkLinkedin", show: true },
    { id: 24, name: "Link Youtube", value: "linkYoutube", show: true },
    { id: 25, name: "Link Tiktok", value: "linkTiktok", show: true },
  ]

  // Productos

  const [products, setProducts] = useState([])
  const [productsModal, setProductsModal] = useState(false)
  const [stakeholderIDSelected, setStakeholderIDSelected] = useState("")
  const [stakeholderNameSelected, setStakeholderNameSelected] = useState("")
  const [creatingNewProduct, setCreatingNewProduct] = useState(false)
  const [newProduct, setNewProduct] = useState({
    name: "",
    description: "",
    price: "",
    type: "",
    costType: "",
  })

  const productHeaders = [
    { id: 1, name: "Nombre del producto" },
    { id: 2, name: "Descripción" },
    { id: 3, name: "Tipo" },
    { id: 4, name: "Categoría" },
    { id: 5, name: "Subcategoría" },
    { id: 6, name: "Moneda" },
    { id: 7, name: "Precio" },
    { id: 8, name: "Tipo de costo" },
    { id: 9, name: "Acciones" },
  ]

  const getProducts = async (id) => {
    if (!id) return
    try {
      const response = await axios.get(`${BACKEND}/api/stakeholdersProducts?limit=0&where[stakeholder][equals]=${id}`)
      setProducts(response.data.docs)
    } catch (e) {
      console.log(e)
      toast.error("Error al obtener los productos")
    }
  }

  const addProduct = async (id) => {
    if (!id) return
    try {
      if (!newProduct.name || !newProduct.description) {
        toast.error("Los campos de nombre y de descripción son obligatorios")
        return
      }

      if (newProduct.costType === "Fijo" && !newProduct.price) {
        toast.error("Si el tipo de costo es Fijo, el precio es obligatorio")
        return
      }

      const confirm = window.confirm("¿Estás seguro de querer agregar este producto? Luego no podrás eliminarlo.")
      if (!confirm) return

      await axios.post(`${BACKEND}/api/stakeholdersProducts`, {
        ...newProduct,
        price: Number(newProduct.price),
        stakeholder: id,
      })
      toast.success("Producto agregado correctamente")
      setNewProduct({ name: "", description: "", price: "", currency: "Soles", type: "" })
      setCreatingNewProduct(false)
      getProducts(id) // Recargar productos después de agregar
    } catch (e) {
      console.log(e)
      toast.error("Error al agregar el producto")
    }
  }

  const deleteProduct = async (id) => {
    if (!id) return
    try {
      const confirm = window.confirm("¿Estás seguro de querer eliminar este producto?")
      if (!confirm) return
      
      await axios.delete(`${BACKEND}/api/stakeholdersProducts/${id}`)
      toast.success("Producto eliminado correctamente")
      getProducts(stakeholderIDSelected) // Recargar productos después de eliminar
    } catch (e) {
      console.log(e)
      toast.error("Error al eliminar el producto")
    }
  }

  const cancelCreateProduct = () => {
    setCreatingNewProduct(false)
    setProductsModal(false)
    setStakeholderIDSelected("")
    setStakeholderNameSelected("")
    setCreatingNewProduct(false)
    setNewProduct({ name: "", description: "", price: "", currency: "Soles", type: "" })
  }

  const [rubros, setRubros] = useState([])
  const [nichos, setNichos] = useState([])

  const [rubroSelected, setRubroSelected] = useState("")
  const [nichoSelected, setNichoSelected] = useState("")

  const getRubros = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/clientesRubros?limit=0`)
      // console.log("Se piden los rubros")
      setRubros(response.data.docs)
    } catch (e) {
      console.log(e)
      toast.error("Error al obtener los rubros")
    }
  }

  const getNichos = async () => {
    try {
      console.log("Se piden los nichos")
      const response = await axios.get(`${BACKEND}/api/clientesNichos?where[rubro][equals]=${rubroSelected.value}&limit=0`)
      console.log(response)
      setNichos(response.data.docs)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    if (rubroSelected === "") {
      setEditStakeholder(prev => ({ ...prev, nicho: "", rubro: "" }))
      setNewStakeholder(prev => ({ ...prev, nicho: "", rubro: "" }))
      setNichoSelected("")
    } else {
      getNichos()
    }
  }, [rubroSelected])

  useEffect(() => {
    getRubros()
  }, [])

  // Seccion categorías y subcategorías
  const [loadingStatusCategories, setLoadingStatusCategories] = useState(false)
  const [loadingStatusSubcategories, setLoadingStatusSubcategories] = useState(false)

  const [categoriesSubcategoriesModal, setCategoriesSubcategoriesModal] = useState(false)

  const [selectedCategory, setSelectedCategory] = useState("")
  const [selectedSubcategory, setSelectedSubcategory] = useState("")
  const [categoryFilter, setCategoryFilter] = useState("")

  const [productCategories, setProductCategories] = useState([])
  const [productSubcategories, setProductSubcategories] = useState([])
  const [productSubcategoriesFilter, setProductSubcategoriesFilter] = useState([])

  const [newCategory, setNewCategory] = useState({ name: "", description: "" })
  const [newSubcategory, setNewSubcategory] = useState({ name: "", description: "" })

  const [editingCategoryId, setEditingCategoryId] = useState(null)
  const [editCategoryForm, setEditCategoryForm] = useState({ categoryName: "" })
  const [editingSubcategoryId, setEditingSubcategoryId] = useState(null)
  const [editSubcategoryForm, setEditSubcategoryForm] = useState({ subcategoryName: "", category: "" })

  const getSubcategoriesForProduct = async (categoryId) => {
    try {
      if (!categoryId) {
        setProductSubcategories([])
        return
      }
      const url = `${BACKEND}/api/stakeholderProductsSubcategories?limit=0&where[category][equals]=${categoryId}`
      const response = await axios.get(url)
      setProductSubcategories(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener subcategorías para la categoría seleccionada")
    }
  }

  const addCategory = async () => {
    try {
      if (!newCategory.name) {
        toast.error("El nombre de la categoría es obligatorio")
        return
      }
      const confirm = window.confirm("¿Estás seguro de querer crear esta categoría? Luego no podrás eliminarla")
      if (!confirm) return
      const payload = {
        categoryName: newCategory.name,
      }
      await axios.post(`${BACKEND}/api/stakeholdersProductsCategories`, payload)
      toast.success("Categoría creada")
      setNewCategory({ name: "", description: "" })
      await getCategories()
    } catch (error) {
      console.log(error)
      toast.error("Error al crear la categoría")
    }
  }

  const addSubcategory = async () => {
    try {
      if (!selectedCategory) {
        toast.error("Selecciona una categoría")
        return
      }
      if (!newSubcategory.name) {
        toast.error("El nombre de la subcategoría es obligatorio")
        return
      }
      const confirm = window.confirm("¿Estás seguro de querer crear esta subcategoría? Luego no podrás eliminarla")
      if (!confirm) return
      const payload = {
        category: selectedCategory,
        subcategoryName: newSubcategory.name,
      }
      await axios.post(`${BACKEND}/api/stakeholderProductsSubcategories`, payload)
      toast.success("Subcategoría creada")
      setNewSubcategory({ name: "", description: "" })
      await getSubcategories()
    } catch (error) {
      console.log(error)
      toast.error("Error al crear la subcategoría")
    }
  }

  const getCategories = async () => {
    try {
      setLoadingStatusCategories(true)
      const response = await axios.get(`${BACKEND}/api/stakeholdersProductsCategories?limit=0`)
      setProductCategories(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener las categorías")
    } finally {
      setLoadingStatusCategories(false)
    }
  }

  const getSubcategories = async () => {
    try {
      setLoadingStatusSubcategories(true)
      let url = `${BACKEND}/api/stakeholderProductsSubcategories?limit=0`
      if (selectedCategory) url += `&where[category][equals]=${selectedCategory}`
      const response = await axios.get(url)
      setProductSubcategories(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener las subcategorías")
    } finally {
      setLoadingStatusSubcategories(false)
    }
  }

  const getSubCategoriesFilter = async () => {
    try {
      let url = (`${BACKEND}/api/stakeholderProductsSubcategories?limit=0`)
      if (categoryFilter) {
        url += `&where[category][equals]=${categoryFilter}`
      }
      const response = await axios.get(url)
      setProductSubcategoriesFilter(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener las subcategorías")
    }
  }

  useEffect(() => {
    getCategories()
  }, [])

  useEffect(() => {
    if (selectedCategory === "") {
      setProductSubcategories([])
      setSelectedSubcategory("")
    } else {
      getSubcategories()
    }
  }, [selectedCategory])

  useEffect(() => {
    getSubCategoriesFilter()
  }, [categoryFilter])

  const startEditCategory = (c) => {
    setEditingCategoryId(c.id)
    setEditCategoryForm({ categoryName: c.categoryName || "" })
  }

  const cancelEditCategory = () => {
    setEditingCategoryId(null)
    setEditCategoryForm({ categoryName: "" })
  }

  const saveEditCategory = async () => {
    try {
      if (!editingCategoryId) return
      await axios.patch(`${BACKEND}/api/stakeholdersProductsCategories/${editingCategoryId}`, { categoryName: editCategoryForm.categoryName })
      toast.success("Categoría actualizada")
      setEditingCategoryId(null)
      await getCategories()
    } catch (error) {
      console.log(error)
      toast.error("Error al actualizar la categoría")
    }
  }

  const startEditSubcategory = (s) => {
    setEditingSubcategoryId(s.id)
    setEditSubcategoryForm({ subcategoryName: s.subcategoryName || "", category: s.category?.id || s.category || "" })
  }

  const cancelEditSubcategory = () => {
    setEditingSubcategoryId(null)
    setEditSubcategoryForm({ subcategoryName: "", category: "" })
  }

  const saveEditSubcategory = async () => {
    try {
      if (!editingSubcategoryId) return
      const payload = { subcategoryName: editSubcategoryForm.subcategoryName, category: editSubcategoryForm.category || null }
      await axios.patch(`${BACKEND}/api/stakeholderProductsSubcategories/${editingSubcategoryId}`, payload)
      toast.success("Subcategoría actualizada")
      setEditingSubcategoryId(null)
      await getSubCategoriesFilter()
    } catch (error) {
      console.log(error)
      toast.error("Error al actualizar la subcategoría")
    }
  }

  useEffect(() => {
    if (newProduct?.category !== undefined) {
      getSubcategoriesForProduct(newProduct.category)
      setNewProduct((prev) => ({ ...prev, subcategory: "" }))
    }
  }, [newProduct.category])

  return (
    <div className="flex flex-col h-screen w-full">

      <FilterHeadersDialog
        activeCols={headersTableActive}
        localStorageKey="activeTableColsStakeholders"
        defaultCols={headers}
        open={openFilter}
        setOpen={setOpenFilter}
        setActiveCols={setHeadersTableActive}
      />

      <Modal // Modal para productos
        activeModal={productsModal}
        onClose={() => {
          setProductsModal(false)
          setStakeholderIDSelected("")
          setStakeholderNameSelected("")
          setCreatingNewProduct(false)
          setNewProduct({ name: "", description: "", price: "", currency: "Soles", type: "" })
        }}
        title="Productos del Stakeholder"
        className="max-w-8xl"
        centered
      >
        <div className="flex flex-col gap-6 pb-4"> 

          {/* Formulario para crear nuevo producto */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-xs font-bold text-gray-700 mb-3">Crear Nuevo Producto</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <InputFormValue
                title="Nombre del Producto"
                info="Nombre del producto"
                placeholder="Nombre del producto"
                value={newProduct.name}
                setValue={(value) => setNewProduct(prev => ({ ...prev, name: value }))}
                icon={<FaBox />}
                type="text"
                required={true}
              />

              <InputFormValue
                title="Descripción del Producto"
                info="Descripción del producto"
                value={newProduct.description}
                placeholder="Descripción del producto"
                setValue={(value) => setNewProduct(prev => ({ ...prev, description: value }))}
                icon={<FaInfo />}
                required={true}
                type="text"
              />

              <InputFormValue
                title="Tipo producto"
                info="Tipo del producto"
                value={newProduct.type}
                setValue={(value) => setNewProduct(prev => ({ ...prev, type: value }))}
                icon={<FaFolder />}
                required={true}
                type="select"
                options={[
                  { value: "", label: "Seleccionar un tipo"}, 
                  ...TiposProducto.map((t) => ({ value: t.value, label: t.label }))
                ]} 
              />

              <InputFormValue
                title="Tipo costo"
                info="Si el tipo de costo es Fijo, el precio es editable y obligatorio, si es Variable, el precio no es obligatorio."
                value={newProduct.costType}
                setValue={(value) => setNewProduct(prev => ({ ...prev, costType: value }))}
                icon={<FaFolder />}
                required={true}
                type="select"
                options={[
                  { value: "", label: "Seleccionar un tipo de costo"}, 
                  ...TiposCosto.map((t) => ({ value: t.value, label: t.label }))
                ]} 
              />

              <InputFormValue
                title="Moneda"
                info="Moneda del producto"
                value={newProduct.currency}
                placeholder="Moneda del producto"
                setValue={(value) => setNewProduct(prev => ({ ...prev, currency: value }))}
                icon={<FaDollarSign />}
                required={true}
                type="select"
                options={[
                  { key: 1, value: "Soles", label: "Soles" }, 
                  { key: 2, value: "Dolares", label: "Dolares" }
                ]} 
              />

              <InputFormValue
                title="Precio del Producto"
                info="Si el tipo de costo es Fijo, el precio es editable y obligatorio, si es Variable, el precio no es obligatorio."
                value={newProduct.price}
                required={newProduct.costType === "Fijo"}
                setValue={(value) => setNewProduct(prev => ({ ...prev, price: value }))}
                icon={<FaMoneyBill />}
                type="number"
                placeholder="Precio del producto"
              />

              <InputFormValue
                title="Categoría"
                info="Categoría del producto"
                value={newProduct.category}
                placeholder="Categoría del producto"
                setValue={(value) => setNewProduct(prev => ({ ...prev, category: value }))}
                icon={<FaBox />}
                type="select"
                options={[
                  { value: "", label: "Seleccionar una categoría" },
                  ...productCategories.map((c) => ({ value: c.id, label: c.categoryName }))
                ]} 
              />

              <InputFormValue
                title="Subcategoría"
                info="Subcategoría del producto"
                value={newProduct.subcategory}
                placeholder="Subcategoría del producto"
                setValue={(value) => setNewProduct(prev => ({ ...prev, subcategory: value }))}
                icon={<FaBox />}
                type="select"
                options={[
                  { value: "", label: "Seleccionar una subcategoría"}, 
                  ...productSubcategories.map((s) => ({ value: s.id, label: s.subcategoryName }))
                ]} 
              />
            </div>

            <div className="flex w-full justify-center items-center gap-2 mt-4">
              <DinamicButton
                action={cancelCreateProduct}
                content="Cancelar"
                backgroundColor="#6b7280"
                hoverBackgroundColor="#4b5563"
                width="50%"
              />
              <DinamicButton
                action={() => addProduct(stakeholderIDSelected)}
                content="Crear Producto"
                icon={<AddIcon />}
                width="50%"
              />
            </div>
          </div>

          {/* Lista de productos existentes */}
          <div className="flex flex-col gap-4">
            <div className="flex flex-row justify-between items-center">
              <h3 className="text-xs font-bold text-gray-700">Productos existentes</h3>
            </div>
            
            <div className="max-h-[40vh] overflow-y-auto rounded-lg">
              {products.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <FaBox className="mx-auto h-12 w-12 text-gray-300 mb-4" />
                  <p className="text-xs">No hay productos registrados para este stakeholder</p>
                </div>
              ) : (
                <div className="bg-white border border-gray-200 rounded-lg">
                  <table className="w-full text-xs">
                    <thead className="bg-gray-100 sticky top-0 z-20">
                      <tr>
                        {productHeaders.map((header, index) => (
                          <th key={index} className="px-4 py-3 text-left text-xs font-medium text-gray-700 tracking-wider">
                            {header.name}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {products.map((product, index) => (
                        <ItemRowProductStakeholder
                          key={product.id || index}
                          product={product}
                          index={index}
                          deleteProduct={deleteProduct}
                          fetcher={getProducts}
                          categories={productCategories}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>

      <Modal // Modal para categorías y subcategorías
        activeModal={categoriesSubcategoriesModal}
        onClose={() => setCategoriesSubcategoriesModal(false)}
        title="Categorías y subcategorías"
        className="max-w-5xl"
        centered
      >
        <div className="flex flex-col gap-6 pb-4">

          {/* Crear nueva categoría */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-xs font-bold text-gray-700 mb-3">Crear nueva categoría</h3>
            <InputFormValue
              title="Nombre de la categoría"
              info="Nombre de la categoría"
              placeholder="Ej. Equipos"
              value={newCategory.name}
              setValue={(value) => setNewCategory(prev => ({ ...prev, name: value }))}
              icon={<FaBox />}
              type="text"
              required={true}
            />
            <div className="flex w-full justify-end items-center gap-2 mt-4">
              <DinamicButton
                action={() => setNewCategory({ name: "", description: "" })}
                content="Limpiar"
                backgroundColor="#6b7280"
                hoverBackgroundColor="#4b5563"
              />
              <DinamicButton
                action={addCategory}
                content="Crear categoría"
                icon={<AddIcon />}
              />
            </div>
          </div>

          {/* Crear nueva subcategoría */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-xs font-bold text-gray-700 mb-3">Crear nueva subcategoría</h3>
 
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="md:col-span-1">
                <InputFormValue
                  title="Categoría"
                  info="Selecciona la categoría"
                  value={selectedCategory}
                  placeholder="Seleccionar"
                  setValue={(value) => setSelectedCategory(value)}
                  icon={<FaBox />}
                  required={true}
                  type="select"
                  options={[{ value: "", label: "Seleccionar una categoría" }, ...productCategories.map((c) => ({ value: c.id, label: c.categoryName }))]}
                />
              </div>
              <div className="md:col-span-2">
                <InputFormValue
                  title="Nombre de la subcategoría"
                  info="Nombre de la subcategoría"
                  placeholder="Ej. Laptops"
                  value={newSubcategory.name}
                  setValue={(value) => setNewSubcategory(prev => ({ ...prev, name: value }))}
                  icon={<FaBox />}
                  type="text"
                  required={true}
                />
              </div>
            </div>
 
 
            <div className="flex w-full justify-end items-center gap-2 mt-4">
              <DinamicButton
                action={() => setNewSubcategory({ name: "", description: "" })}
                content="Limpiar"
                backgroundColor="#6b7280"
                hoverBackgroundColor="#4b5563"
              />
              <DinamicButton
                action={addSubcategory}
                content="Crear subcategoría"
                icon={<AddIcon />}
                disabled={!selectedCategory}
              />
            </div>
          </div>

          {/* Listados */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            
            {/* Categoría */}
            <div className="bg-white border border-gray-200 md:col-span-1 rounded-lg">
              <div className="flex items-center justify-between p-3">
                <h4 className="text-xs font-bold text-gray-700">Categorías</h4>
                <DinamicBoxButton content="Refrescar" action={getCategories} color="gray" icon={<FaSync className="text-[10px]" />} />
              </div>
              <div className="max-h-[30vh] overflow-y-auto">
                <table className="w-full text-xs">
                  <thead className="bg-gray-100 sticky top-0 z-20">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-700">Nombre</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-700">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {productCategories.map((c) => (
                      <tr key={c.id} className="hover:bg-gray-50">
                        <td className="px-4 py-2">
                          {editingCategoryId === c.id ? (
                            <InputRowValue
                              type="text"
                              title=""
                              width="w-full"
                              value={editCategoryForm.categoryName}
                              setValue={(v) => setEditCategoryForm((st) => ({ ...st, categoryName: v }))}
                            />
                          ) : (
                            c.categoryName
                          )}
                        </td>
                        <td className="px-4 py-2">
                          {editingCategoryId === c.id ? (
                            <div className="flex items-center gap-2">
                              <DinamicBoxButton content="Guardar" color="green" icon={<FaSave />} action={saveEditCategory} />
                              <DinamicBoxButton content="Cancelar" color="red" icon={<FaTimes />} action={cancelEditCategory} />
                            </div>
                          ) : (
                            <DinamicBoxButton content="Editar" color="blue" icon={<FaEdit />} action={() => startEditCategory(c)} />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Subcategoría */}
            <div className="bg-white border border-gray-200 md:col-span-2 rounded-lg">
              <div className="flex items-center justify-between p-3">
                <h4 className="text-xs font-bold text-gray-700">Subcategorías</h4>
                <div className="flex items-center gap-2">
                  <Selector
                    title="Categoría"
                    options={[{ value: "", label: "Todas" }, ...productCategories.map((c) => ({ value: c.id, label: c.categoryName }))]}
                    value={categoryFilter}
                    setter={setCategoryFilter}
                  />
                  <DinamicBoxButton content="Refrescar" action={getSubCategoriesFilter} color="gray" icon={<FaSync className="text-[10px]" />} />
                </div>
              </div>
              <div className="max-h-[30vh] overflow-y-auto">
                <table className="w-full text-xs">
                  <thead className="bg-gray-100 sticky top-0 z-20">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-700">Nombre</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-700">Categoría</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-700">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {productSubcategoriesFilter.map((s) => (
                      <tr key={s.id} className="hover:bg-gray-50">
                        <td className="px-4 py-2">
                          {editingSubcategoryId === s.id ? (
                            <InputRowValue
                              type="text"
                              title=""
                              width="w-full"
                              value={editSubcategoryForm.subcategoryName}
                              setValue={(v) => setEditSubcategoryForm((st) => ({ ...st, subcategoryName: v }))}
                            />
                          ) : (
                            s.subcategoryName
                          )}
                        </td>
                        <td className="px-4 py-2 text-gray-600">
                          {editingSubcategoryId === s.id ? (
                            <InputRowValue
                              type="select"
                              title=""
                              width="w-full"
                              value={editSubcategoryForm.category}
                              setValue={(v) => setEditSubcategoryForm((st) => ({ ...st, category: v }))}
                              options={productCategories.map((c) => ({ value: c.id, label: c.categoryName }))}
                            />
                            // <select
                            //   className="border border-gray-300 rounded px-2 py-1 w-full"
                            //   value={editSubcategoryForm.category}
                            //   onChange={(e) => setEditSubcategoryForm((st) => ({ ...st, category: e.target.value }))}
                            // >
                            //   <option value="">Sin categoría</option>
                            //   {productCategories.map((c) => (
                            //     <option key={c.id} value={c.id}>{c.categoryName}</option>
                            //   ))}
                            // </select>
                          ) : (
                            s.category?.categoryName || '-'
                          )}
                        </td>
                        <td className="px-4 py-2">
                          {editingSubcategoryId === s.id ? (
                            <div className="flex items-center gap-2">
                              <DinamicBoxButton content="Guardar" color="green" icon={<FaSave />} action={saveEditSubcategory} />
                              <DinamicBoxButton content="Cancelar" color="red" icon={<FaTimes />} action={cancelEditSubcategory} />
                            </div>
                          ) : (
                            <DinamicBoxButton content="Editar" color="blue" icon={<FaEdit />} action={() => startEditSubcategory(s)} />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          
        </div>
      </Modal>

      <Modal // Modal para crear nuevos proveedores
        activeModal={newStakeholderModal}
        onClose={() => setNewStakeholderModal(false)}
        title="Crear nuevo stakeholder"
        className="max-w-3xl"
        centered
      >
        <form onSubmit={(e) => SubmitStakeholder(e)}>

          <div className="flex flex-col gap-4 max-h-[70vh] overflow-y-auto pb-4">
            
            <span className="text-xs text-black font-bold">Información del stakeholder</span>

            <div className="flex flex-row gap-4">

              <div className="flex flex-col w-full justify-start gap-4">

                {/* País */}
                <InputFormValue
                  required={true}
                  title="País"
                  info="País del stakeholder"
                  value={newStakeholder.country}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, country: value }))}
                  icon={<FaMapMarkerAlt />}
                  placeholder="País del stakeholder"
                  type="select"
                  options={countries.map((c, i) => ({
                    key: i,
                    value: c.name,
                    label: c.name
                  }))}
                />

                {/* RUC */}
                <div className="flex flex-col gap-1">
                  <label className="text-xs block text-gray-700">
                      RUC
                  </label>
                  <div className="flex">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaIdCardAlt />
                    </span>
                    <input
                      type="text"
                      placeholder="RUC del usuario"
                      value={newStakeholder.ruc}
                      onChange={(e) => setNewStakeholder((prev) => ({...prev, ruc: e.target.value}))}
                      className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />

                    {rucVerify ? (
                      <div className="inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border border-s-0 rounded-e-0 border-gray-300 border-e-0 rounded-e-md ">
                        Validado
                        <FaCheck className=" text-white" />
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={() => RucVerifier({ruc: newStakeholder.ruc, rucSetter: setRucVerify, setter: setNewStakeholder, nameBrand: "socialReason", address: "address"})}
                        disabled={isRucLoading}
                        className="inline-flex  gap-2 items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-s-0 rounded-e-md "
                      >
                        {isRucLoading ? (
                          <FormLoader colour={"#F64000"} className={"w-4"} />
                        ) : (
                          <>
                            Validar
                            <FaCheck />
                          </>
                        )}
                      </button>
                    )}
                  </div>
                </div>

                {/* Fecha de fundación */}
                <InputFormValue
                  title="Fecha de fundación"
                  info="Fecha de fundación de la empresa"
                  value={newStakeholder.foundationDate}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, foundationDate: value }))}
                  icon={<FaCalendar />}
                  placeholder="Fecha de fundación de la empresa"
                  type="date"
                />

                {/* Número de empleados */}
                <InputFormValue
                  title="Número de empleados"
                  info="Número de empleados de la empresa"
                  value={newStakeholder.numberOfEmployees}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, numberOfEmployees: value }))}
                  icon={<FaUser />}
                  placeholder="Número de empleados de la empresa"
                  type="select"
                  options={[
                    { value: "1-10", label: "1-10" },
                    { value: "11-50", label: "11-50" },
                    { value: "51-100", label: "51-100" },
                    { value: "101-500", label: "101-500" },
                    { value: "501-1000", label: "501-1000" },
                  ]}
                />

                {/* Descripcion */}
                <InputFormValue
                  title="Descripción"
                  info="Descripción de la empresa"
                  value={newStakeholder.description}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, description: value }))}
                  icon={<FaInfo />}
                  placeholder="Descripción de la empresa"
                  type="text"
                />

                {/* Nombre del gerente */}
                <InputFormValue
                  title="Nombre del gerente"
                  info="Nombre del gerente de la empresa"
                  value={newStakeholder.managerName}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, managerName: value }))}
                  icon={<FaUser />}
                  placeholder="Nombre del gerente de la empresa"
                  type="text"
                />

                {/* Email del gerente */}
                <InputFormValue
                  title="Email del gerente"
                  info="Email del gerente de la empresa"
                  value={newStakeholder.managerEmail}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, managerEmail: value }))}
                  icon={<MdEmail />}
                  placeholder="Email del gerente de la empresa"
                  type="text"
                />

                {/* Fecha de nacimiento del gerente */}
                <InputFormValue
                  title="Fecha de nacimiento del gerente"
                  info="Fecha de nacimiento del gerente de la empresa"
                  value={newStakeholder.managerBirthday}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, managerBirthday: value }))}
                  icon={<FaBirthdayCake />}
                  placeholder="Fecha de nacimiento del gerente de la empresa"
                  type="date"
                />

                {/* Teléfono del gerente */}
                <InputFormValue
                  title="Teléfono del gerente"
                  info="Teléfono del gerente de la empresa"
                  value={newStakeholder.managerPhone}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, managerPhone: value }))}
                  icon={<FaPhone />}
                  placeholder="Teléfono del gerente de la empresa"
                  type="text"
                />

              </div>

              <div className="flex flex-col w-full justify-start gap-4">

                {/* Sector empresarial */}
                {/* <InputFormValue
                  title="Sector empresarial"
                  info="Sector empresarial de la empresa"
                  value={newStakeholder.businessSector}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, businessSector: value }))}
                  icon={<FaIndustry />}
                  placeholder="Sector empresarial de la empresa"
                  type="text"
                /> */}

                {/* Rubro */}
                <InputFormValue
                  title="Rubro"
                  info="Rubro de la empresa"
                  value={newStakeholder.rubro}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, rubro: value }))}
                  onSelectOption={(value) => setRubroSelected(value)}
                  icon={<MdWorkspaces/>}
                  placeholder="Rubro de la empresa"
                  type="select"
                  options={[{value: "", label: "Seleccionar un rubro"}, ...rubros.map((rubro) => ({
                    value: rubro.id,
                    label: rubro.name
                  }))]}
                />

                {/* Nicho */}
                <InputFormValue
                  title="Nicho"
                  info="Nicho de la empresa"
                  value={newStakeholder.nicho}
                  onSelectOption={(value) => setNichoSelected(value)}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, nicho: value }))}
                  icon={<MdWorkspaces/>}
                  placeholder="Nicho de la empresa"
                  type="select"
                  options={[{value: "", label: "Seleccionar un nicho"}, ...nichos.map((nicho) => ({
                    value: nicho.id,
                    label: nicho.name
                  }))]}
                />

                {/* Razón Social */}
                <InputFormValue
                  title="Razón Social"
                  info="Razón social del stakeholder"
                  value={newStakeholder.socialReason}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, socialReason: value }))}
                  icon={<MdPerson />}
                  placeholder="Razón social del stakeholder"
                  type="text"
                />

                {/* Nombre Comercial */}
                <InputFormValue
                  required={true}
                  title="Nombre Comercial"
                  info="Nombre comercial del stakeholder"
                  value={newStakeholder.commercialName}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, commercialName: value }))}
                  icon={<FaIdCardAlt />}
                  placeholder="Nombre comercial del stakeholder"
                  type="text"
                />

                {/* Dirección */}
                <InputFormValue
                  title="Dirección"
                  info="Dirección del stakeholder"
                  value={newStakeholder.address}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, address: value }))}
                  icon={<FaMapMarkerAlt />}
                  placeholder="Dirección del stakeholder"
                  type="text"
                />

                {/* Email de ventas */}
                <InputFormValue
                  title="Email de ventas"
                  info="Email de ventas de la empresa"
                  value={newStakeholder.salesEmail}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, salesEmail: value }))}
                  icon={<MdEmail />}
                  placeholder="Email de ventas de la empresa"
                  type="text"
                />

                {/* Teléfono de ventas */}
                <InputFormValue
                  title="Teléfono de ventas"
                  info="Teléfono de ventas de la empresa"
                  value={newStakeholder.salesPhone}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, salesPhone: value }))}
                  icon={<FaPhone />}
                  placeholder="Teléfono de ventas de la empresa"
                  type="text"
                />

                {/* Email */}
                <InputFormValue
                  title="Email"
                  info="Email de la empresa"
                  value={newStakeholder.email}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, email: value }))}
                  icon={<MdEmail />}
                  placeholder="Email de la empresa"
                  type="text"
                />

                {/* Teléfono */}
                <InputFormValue
                  title="Teléfono"
                  info="Teléfono de la empresa"
                  value={newStakeholder.phone}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, phone: value }))}
                  icon={<FaPhone />}
                  placeholder="Teléfono de la empresa"
                  type="text"
                />
              
              </div>
          
            </div>

            <hr className="mt-4" />

            <span className="text-xs text-black font-bold">Redes sociales</span>

            <div className="flex flex-row gap-4">

              <div className="flex flex-col gap-2 w-1/2">
                <InputFormValue
                  title="Link Facebook"
                  info="Link Facebook de la empresa"
                  value={newStakeholder.linkFacebook}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, linkFacebook: value }))}
                  icon={<FaGlobe />}
                  placeholder="Link Facebook de la empresa"
                  type="text"
                />
                <InputFormValue
                  title="Link Instagram"
                  info="Link Instagram de la empresa"
                  value={newStakeholder.linkInstagram}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, linkInstagram: value }))}
                  icon={<FaGlobe />}
                  placeholder="Link Instagram de la empresa"
                  type="text"
                />
                <InputFormValue
                  title="Link Linkedin"
                  info="Link Linkedin de la empresa"
                  value={newStakeholder.linkLinkedin}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, linkLinkedin: value }))}
                  icon={<FaGlobe />}
                  placeholder="Link Linkedin de la empresa"
                  type="text"
                />
              </div>

              <div className="flex flex-col gap-2 w-1/2">
                <InputFormValue
                  title="Link Youtube"
                  info="Link Youtube de la empresa"
                  value={newStakeholder.linkYoutube}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, linkYoutube: value }))}
                  icon={<FaGlobe />}
                  placeholder="Link Youtube de la empresa"
                  type="text"
                />
                <InputFormValue
                  title="Link Tiktok"
                  info="Link Tiktok de la empresa"
                  value={newStakeholder.linkTiktok}
                  setValue={(value) => setNewStakeholder(prev => ({ ...prev, linkTiktok: value }))}
                  icon={<FaGlobe />}
                  placeholder="Link Tiktok de la empresa"
                  type="text"
                />
              </div>

            </div>
          </div>

          <div className="flex flex-row gap-4">
            <Button 
              variant="contained"
              type="submit"
              onClick={() => setNewStakeholderModal(false)}
              sx={{
                fontWeight: "bold",
                fontFamily: "poppins",
                fontSize: "12px",
                paddingBlock: "4px",
                backgroundColor: "#6b7280",
                transform: "all",
                marginTop: "20px",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                width: "100%",
                '&:hover': {
                  backgroundColor: "#4b5563",
                }
              }}
            >
              Cancelar
            </Button>

            <Button 
              variant="contained"
              type="submit"
              sx={{
                fontWeight: "bold",
                fontFamily: "poppins",
                fontSize: "12px",
                paddingBlock: "4px",
                backgroundColor: "#ff6400",
                transform: "all",
                marginTop: "20px",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                width: "100%",
                '&:hover': {
                  backgroundColor: "#bb4a03",
                }
              }}
            >
              Guardar
            </Button>
          </div>

        </form>
      </Modal>

      <Modal // Modal para editar proveedores
        activeModal={editStakeholderModal}
        onClose={() => setEditStakeholderModal(false)}
        title="Editar stakeholder"
        className="max-w-3xl"
        centered
      >
        <div>

          <div className="flex flex-col gap-4 max-h-[70vh] overflow-y-auto pb-4">
            
            <span className="text-xs text-black font-bold">Información del stakeholder</span>

            <div className="flex flex-row gap-4">

              <div className="flex flex-col w-full justify-start gap-4">

                {/* País */}
                <InputFormValue
                  required={true}
                  title="País"
                  info="País del stakeholder"
                  value={editStakeholder.country}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, country: value }))}
                  icon={<FaMapMarkerAlt />}
                  placeholder="País del stakeholder"
                  type="select"
                  options={countries.map((c, i) => ({
                    key: i,
                    value: c.name,
                    label: c.name
                  }))}
                />

                {/* RUC */}
                <div className="flex flex-col gap-1">
                  <label className="text-xs block text-gray-700">
                      RUC
                  </label>
                  <div className="flex">
                    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                      <FaIdCardAlt />
                    </span>
                    <input
                      type="text"
                      placeholder="RUC del usuario"
                      value={editStakeholder.ruc}
                      onChange={(e) => setEditStakeholder((prev) => ({...prev, ruc: e.target.value}))}
                      className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                    />

                    {rucVerify ? (
                      <div className="inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border border-s-0 rounded-e-0 border-gray-300 border-e-0 rounded-e-md ">
                        Validado
                        <FaCheck className=" text-white" />
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={() => RucVerifier({ruc: editStakeholder.ruc, rucSetter: setRucVerify, setter: setEditStakeholder, nameBrand: "socialReason", address: "address"})}
                        disabled={isRucLoading}
                        className="inline-flex  gap-2 items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-s-0 rounded-e-md "
                      >
                        {isRucLoading ? (
                          <FormLoader colour={"#F64000"} className={"w-4"} />
                        ) : (
                          <>
                            Validar
                            <FaCheck />
                          </>
                        )}
                      </button>
                    )}
                  </div>
                </div>

                {/* Fecha de fundación */}
                <InputFormValue
                  title="Fecha de fundación"
                  info="Fecha de fundación de la empresa"
                  value={editStakeholder.foundationDate}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, foundationDate: value }))}
                  icon={<FaCalendar />}
                  placeholder="Fecha de fundación de la empresa"
                  type="date"
                />

                {/* Número de empleados */}
                <InputFormValue
                  title="Número de empleados"
                  info="Número de empleados de la empresa"
                  value={editStakeholder.numberOfEmployees}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, numberOfEmployees: value }))}
                  icon={<FaUser />}
                  placeholder="Número de empleados de la empresa"
                  type="select"
                  options={[
                    { value: "1-10", label: "1-10" },
                    { value: "11-50", label: "11-50" },
                    { value: "51-100", label: "51-100" },
                    { value: "101-500", label: "101-500" },
                    { value: "501-1000", label: "501-1000" },
                  ]}
                />

                {/* Descripcion */}
                <InputFormValue
                  title="Descripción"
                  info="Descripción de la empresa"
                  value={editStakeholder.description}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, description: value }))}
                  icon={<FaInfo />}
                  placeholder="Descripción de la empresa"
                  type="text"
                />

                {/* Nombre del gerente */}
                <InputFormValue
                  title="Nombre del gerente"
                  info="Nombre del gerente de la empresa"
                  value={editStakeholder.managerName}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, managerName: value }))}
                  icon={<FaUser />}
                  placeholder="Nombre del gerente de la empresa"
                  type="text"
                />

                {/* Email del gerente */}
                <InputFormValue
                  title="Email del gerente"
                  info="Email del gerente de la empresa"
                  value={editStakeholder.managerEmail}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, managerEmail: value }))}
                  icon={<MdEmail />}
                  placeholder="Email del gerente de la empresa"
                  type="text"
                />

                {/* Fecha de nacimiento del gerente */}
                <InputFormValue
                  title="Fecha de nacimiento del gerente"
                  info="Fecha de nacimiento del gerente de la empresa"
                  value={editStakeholder.managerBirthday}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, managerBirthday: value }))}
                  icon={<FaBirthdayCake />}
                  placeholder="Fecha de nacimiento del gerente de la empresa"
                  type="date"
                />

                {/* Teléfono del gerente */}
                <InputFormValue
                  title="Teléfono del gerente"
                  info="Teléfono del gerente de la empresa"
                  value={editStakeholder.managerPhone}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, managerPhone: value }))}
                  icon={<FaPhone />}
                  placeholder="Teléfono del gerente de la empresa"
                  type="text"
                />

              </div>

              <div className="flex flex-col w-full justify-start gap-4">

                {/* Sector empresarial */}
                {/* <InputFormValue
                  title="Sector empresarial"
                  info="Sector empresarial de la empresa"
                  value={editStakeholder.businessSector}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, businessSector: value }))}
                  icon={<FaIndustry />}
                  placeholder="Sector empresarial de la empresa"
                  type="text"
                /> */}

                {/* Rubro */}
                <InputFormValue
                  title="Rubro"
                  info="Rubro de la empresa"
                  value={editStakeholder.rubro}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, rubro: value }))}
                  onSelectOption={(value) => setRubroSelected(value)}
                  icon={<MdWorkspaces/>}
                  placeholder="Rubro de la empresa"
                  type="select"
                  options={[{value: "", label: "Seleccionar un rubro"}, ...rubros.map((rubro) => ({
                    value: rubro.id,
                    label: rubro.name
                  }))]}
                />

                {/* Nicho */}
                <InputFormValue
                  title="Nicho"
                  info="Nicho de la empresa"
                  value={editStakeholder.nicho}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, nicho: value }))}
                  onSelectOption={(value) => setNichoSelected(value)}
                  icon={<MdWorkspaces/>}
                  placeholder="Nicho de la empresa"
                  type="select"
                  options={[{value: "", label: "Seleccionar un nicho"}, ...nichos.map((nicho) => ({
                    value: nicho.id,
                    label: nicho.name
                  }))]}
                />

                {/* Razón Social */}
                <InputFormValue
                  title="Razón Social"
                  info="Razón social del stakeholder"
                  value={editStakeholder.socialReason}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, socialReason: value }))}
                  icon={<MdPerson />}
                  placeholder="Razón social del stakeholder"
                  type="text"
                />

                {/* Nombre Comercial */}
                <InputFormValue
                  required={true}
                  title="Nombre Comercial"
                  info="Nombre comercial del stakeholder"
                  value={editStakeholder.commercialName}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, commercialName: value }))}
                  icon={<FaIdCardAlt />}
                  placeholder="Nombre comercial del stakeholder"
                  type="text"
                />

                {/* Dirección */}
                <InputFormValue
                  title="Dirección"
                  info="Dirección del stakeholder"
                  value={editStakeholder.address}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, address: value }))}
                  icon={<FaMapMarkerAlt />}
                  placeholder="Dirección del stakeholder"
                  type="text"
                />

                {/* Email de ventas */}
                <InputFormValue
                  title="Email de ventas"
                  info="Email de ventas de la empresa"
                  value={editStakeholder.salesEmail}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, salesEmail: value }))}
                  icon={<MdEmail />}
                  placeholder="Email de ventas de la empresa"
                  type="text"
                />

                {/* Teléfono de ventas */}
                <InputFormValue
                  title="Teléfono de ventas"
                  info="Teléfono de ventas de la empresa"
                  value={editStakeholder.salesPhone}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, salesPhone: value }))}
                  icon={<FaPhone />}
                  placeholder="Teléfono de ventas de la empresa"
                  type="text"
                />

                {/* Email */}
                <InputFormValue
                  title="Email"
                  info="Email de la empresa"
                  value={editStakeholder.email}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, email: value }))}
                  icon={<MdEmail />}
                  placeholder="Email de la empresa"
                  type="text"
                />

                {/* Teléfono */}
                <InputFormValue
                  title="Teléfono"
                  info="Teléfono de la empresa"
                  value={editStakeholder.phone}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, phone: value }))}
                  icon={<FaPhone />}
                  placeholder="Teléfono de la empresa"
                  type="text"
                />
              
              </div>
          
            </div>

            <hr className="mt-4" />

            <span className="text-xs text-black font-bold">Redes sociales</span>

            <div className="flex flex-row gap-4">

              <div className="flex flex-col gap-2 w-1/2">
                <InputFormValue
                  title="Link Facebook"
                  info="Link Facebook de la empresa"
                  value={editStakeholder.linkFacebook}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, linkFacebook: value }))}
                  icon={<FaGlobe />}
                  placeholder="Link Facebook de la empresa"
                  type="text"
                />
                <InputFormValue
                  title="Link Instagram"
                  info="Link Instagram de la empresa"
                  value={editStakeholder.linkInstagram}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, linkInstagram: value }))}
                  icon={<FaGlobe />}
                  placeholder="Link Instagram de la empresa"
                  type="text"
                />
                <InputFormValue
                  title="Link Linkedin"
                  info="Link Linkedin de la empresa"
                  value={editStakeholder.linkLinkedin}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, linkLinkedin: value }))}
                  icon={<FaGlobe />}
                  placeholder="Link Linkedin de la empresa"
                  type="text"
                />
              </div>

              <div className="flex flex-col gap-2 w-1/2">
                <InputFormValue
                  title="Link Youtube"
                  info="Link Youtube de la empresa"
                  value={editStakeholder.linkYoutube}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, linkYoutube: value }))}
                  icon={<FaGlobe />}
                  placeholder="Link Youtube de la empresa"
                  type="text"
                />
                <InputFormValue
                  title="Link Tiktok"
                  info="Link Tiktok de la empresa"
                  value={editStakeholder.linkTiktok}
                  setValue={(value) => setEditStakeholder(prev => ({ ...prev, linkTiktok: value }))}
                  icon={<FaGlobe />}
                  placeholder="Link Tiktok de la empresa"
                  type="text"
                />
              </div>

            </div>
          </div>

          <div className="flex flex-row gap-4">
            <Button 
              variant="contained"
              type="button"
              onClick={() => setEditStakeholderModal(false)}
              sx={{
                fontWeight: "bold",
                fontFamily: "poppins",
                fontSize: "12px",
                paddingBlock: "4px",
                backgroundColor: "#6b7280",
                transform: "all",
                marginTop: "20px",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                width: "100%",
                '&:hover': {
                  backgroundColor: "#4b5563",
                }
              }}
            >
              Cancelar
            </Button>

            <Button 
              variant="contained"
              type="submit"
              onClick={() => UpdateStakeholder()}
              sx={{
                fontWeight: "bold",
                fontFamily: "poppins",
                fontSize: "12px",
                paddingBlock: "4px",
                backgroundColor: "#ff6400",
                transform: "all",
                marginTop: "20px",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                width: "100%",
                '&:hover': {
                  backgroundColor: "#bb4a03",
                }
              }}
            >
                Actualizar
            </Button>
          </div>

        </div>
      </Modal>

      {/* Header */}
      <div className="flex flex-row px-6 py-2 w-full bg-gray-100 flex flex-row justify-between items-center">
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          <div className="flex items-center gap-4 py-4">
              <FaUsersCog className="text-zinc-700 text-2xl" />
              <h2 className="text-2xl font-bold text-zinc-700">Proveedores</h2>
          </div>
        </div>

        <div className="flex flex-row gap-8 items-center justify-center">

          <Selector
            title="Límite"
            setter={setLimit}
            value={limit}
            width="w-[5rem]"
            options={[
              { value: 20, label: "20" },
              { value: 30, label: "30" },
              { value: 40, label: "40" },
              { value: 50, label: "50" },
              { value: 100, label: "100" },
            ]}
          />

          <div className="relative w-full">
            <input
              type="text"
              placeholder="Buscar por nombre comercial"
              className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {name && (
              <FaTimes
                onClick={() => handleResetSearch()}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
              />
            )}
          </div>

          <div>
            <Button
              variant="contained"
              endIcon={<SearchIcon />}
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: "poppins",
                padding: "4px 24px",
                backgroundColor: "#ff6400",
                transform: "all",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                '&:hover': {
                  backgroundColor: "#bb4a03",
                }
              }}
              onClick={() => handleSearchRecord()}
            >
              Buscar
            </Button>
          </div>

        </div>

      </div>

      {/* Filtros */}
      <div className="flex flex-row px-4 bg-gray-100 mt-0.5">
        <div className="flex flex-row w-full py-1 items-center gap-4 justify-center overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row w-full gap-4 items-center justify-center px-6">

            <DinamicButton 
              content="Categorías y subcateagorías"
              action={() => setCategoriesSubcategoriesModal(true)}
              icon={<FaBox className="text-[10px]" />}
              iconSize={12}
              disabled={loadingStatusCategories || loadingStatusSubcategories}
            />

            <DinamicButton 
              content="Crear nuevo stakeholder"
              action={() => setNewStakeholderModal(true)}
              icon={<AddIcon />}
            />

            <FilterButton
              content="Headers"
              action={() => setOpenFilter(true)}
            />

          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
        ) : (
          record.length === 0 ? (
            <NoDataScreen />
          ) : (
            <table className="w-full text-xs">
              <thead className="text-xs sticky top-0 text-gray-900 bg-gray-200 z-20">
                <tr className="text-gray-700 text-center text-xs font-bold">
                  {headers.map((header, i) => {
                    return (
                      <td key={i} className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                        {header.name}
                      </td>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {record.map((s, i) => {
                  return (
                    <tr key={s.id} className="text-xs py-3 w-full hover:bg-gray-100 transition-all duration-100">
                      {headers.map((header, idx) => (
                        headersTableActive.find((e) => e.id === header.id)?.show && (
                          header.value === "actions" ? (
                            <td key={idx} scope="row" className="px-4 py-3  text-center whitespace-nowrap border border-gray-300">
                              <div className="flex flex-row gap-2 justify-center">
                                <EditButton
                                  content="Editar registro"
                                  action={() => {
                                    setEditStakeholder(formatStakeholderForEdit(s))
                                    setEditStakeholderModal(true)
                                  }}
                                />
                                {/* <DeleteButton
                                  content="Eliminar registro"
                                  action={() => DeleteStakeholder(s.id)}
                                /> */}
                                <DinamicBoxButton 
                                  content="Productos"
                                  color="orange"
                                  icon={<FaBox className="text-[10px]" />}
                                  action={() => {
                                    setStakeholderIDSelected(s.id)
                                    setStakeholderNameSelected(s.commercialName || s.socialReason)
                                    setProductsModal(true)
                                    getProducts(s.id)
                                  }}
                                />
                              </div>
                            </td>
                          ) : (
                            <td key={idx} scope="row" className="px-2 py-1 max-w-[15rem] border border-gray-300 truncate text-center z-10">
                              {header.formatter ? header.formatter(s[header.value]) : s[header.value] || "-"} 
                            </td>
                          )
                        ))
                      )}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          )
        )}
      </div>

      {/* Paginador */}
      <PaginationItem 
        actualDocs={record.length}
        totalDocs={totalDocs}
        entity="stakeholders"
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />

    </div>
  )
}

export default Stakeholders